<template>
  <!--<div id="header-banner" v-bind:style="{ backgroundImage: 'url(' + banner.mediaUrl + ')' }">-->
  <div id="header-banner" >
    <div v-if="banner && banner.mediaUrl" id="header-banner-video">
      <video preload="auto" autoplay muted loop playsinline>
        <source v-bind:src="banner.mediaUrl" type="video/mp4">
      </video>
    </div>

    <div class="title-wrapper">
      <span class="banner-title-orange">{{banner.tekstOranje}}&nbsp;</span>
      <span class="banner-title-white">{{banner.tekstWit}}&nbsp;</span>
      <span class="banner-title-orange">{{banner.tekstOranje2}}</span>
    </div>
  </div>
</template>

<script>
  import { services, EventBus } from '../Services/Services'

  export default {
    data: function () {
      return {
        banner: services.Banner
      };
    },

    created: function () {
      EventBus.$on('reload-header-banner', function (data) {
       // console.log('reloaded header-banner');
        var video = $('#header-banner video:visible');
        if (video.length) {
          video.each(function (e) {
            this.load(); this.play();
          });
        }
      });
    },

    computed: {
      //banner: function () {
      //  return (services.Banner ? services.Banner.mediaUrl : "");
      //}
    }
  }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/header-banner.vue